'use client';

import React, { useState } from 'react';
import Image from 'next/image';
import { Tabs, TabOption } from '@baseline/ui';
import commonStyles from '@/app/(website)/commonStyles.module.scss';
import styles from './productFeatureTabs.module.scss';
import { Data } from '@strapi/strapi';
import { buildImageSrc } from '@/services/formatUtils';

type ProductFeatureTabsProps = Partial<
  Data.Component<'shared.feature-product-tabs'>
> & {
  defaultTab?: string;
};

const ProductFeatureTabs: React.FC<ProductFeatureTabsProps> = ({
  header,
  tab_group,
  defaultTab
}) => {
  const [activeTab, setActiveTab] = useState<string>(
    defaultTab || tab_group?.[0]?.id?.toString() || ''
  );

  if (!tab_group || tab_group.length === 0) {
    return null;
  }

  const tabOptions: TabOption<string>[] = tab_group.map((tab) => ({
    value: tab.id?.toString() || '',
    label: tab.tab_label || '',
    content: (
      <div className={styles.tabContent}>
        <div className={styles.imageContainer}>
          {tab.tab_image?.url && (
            <Image
              src={buildImageSrc(tab.tab_image.url)}
              alt={tab.tab_image.alternativeText || tab.tab_label || ''}
              fill
              className={styles.image}
            />
          )}
        </div>
        {tab.tab_header && (
          <div className={styles.titleContainer}>
            <h4
              className={`${styles.title} ${commonStyles.sectionSubheadingH4}`}
            >
              {tab.tab_header}
            </h4>
          </div>
        )}
        {tab.tab_description && (
          <p className={`${styles.description} ${commonStyles.sectionBody}`}>
            {tab.tab_description}
          </p>
        )}
      </div>
    )
  }));

  return (
    <section
      className={`${styles.productFeatureTabs} ${commonStyles.sectionContent}`}
    >
      <div className={`${styles.content}`}>
        <h2 className={`${styles.header} ${commonStyles.sectionSubheadingH2}`}>
          {header}
        </h2>
        <div className={styles.tabsContainer}>
          <Tabs
            options={tabOptions}
            value={activeTab}
            onChange={setActiveTab}
            className={styles.tabs}
          />
        </div>
      </div>
    </section>
  );
};

export default ProductFeatureTabs;
